export default {
  // Header
  header: {
    home: 'Início',
    about: 'Sobre',
    services: 'Serviços',
    contact: 'Contato'
  },

  // Shabbat notice
  shabbat: {
    notice: 'Estamos em observância do Shabat. Retornaremos após o pôr do sol de sábado.'
  },

  // Hero Section
  hero: {
    title: 'Transformamos Ideias em',
    titleHighlight: 'Soluções Digitais',
    subtitle: 'Desenvolvimento personalizado, consultoria técnica e suporte especializado',
    ctaClients: 'Conheça Nossos Clientes',
    ctaContact: 'Fale Conosco',
    mysteryQuote: 'Algo extraordinário está sendo forjado no reino digital...',
    description: 'Onde a inteligência artificial encontra a engenhosidade humana, onde a automação transcende fronteiras, e onde o futuro da tecnologia se desdobra diante dos seus olhos.',
    comingSoon: 'Em Breve',
    mysteryText: 'A revolução começa...',
    joinFuture: 'Junte-se ao Futuro',
    stats: {
      experience: 'Anos de Experiência',
      innovation: 'Inovação',
      powered: 'Impulsionado'
    }
  },
  
  // Clients Section
  clients: {
    title: 'Clientes',
    subtitle: 'Confira alguns de nossos clientes'
  },

  // Features Section
  features: {
    title: 'Nossos Serviços',
    subtitle: 'Nossos serviços especializados para impulsionar sua transformação digital',
    badge: 'Especialidade',
    development: {
      title: 'Desenvolvimento Personalizado',
      description: 'Criação de soluções sob medida que atendem às necessidades específicas de cada cliente, utilizando as melhores práticas de engenharia de software, design responsivo e tecnologias modernas.'
    },
    consulting: {
      title: 'Consultoria Técnica',
      description: 'Planejamento, desenho e implementação de arquiteturas robustas, garantindo alta disponibilidade, segurança e desempenho para sua infraestrutura ou aplicação.'
    },
    support: {
      title: 'Suporte Técnico',
      description: 'Atendimento especializado para resolução de problemas em servidores, redes, sistemas e ambientes corporativos. Atuamos de forma proativa para manter seus serviços sempre disponíveis e seguros.'
    }
  },
  
  // Contact Section
  contact: {
    title: 'Contato',
    email: 'Email',
    phone: 'Telefone',
    schedule: 'Horário',
    scheduleText: 'Segunda a Quinta: 08:00 - 18:00',
    scheduleTime: 'Sexta: 08:00 - 14:00',
    prepareTitle: 'Prepare-se',
    titleHighlight: 'para o Futuro',
    subtitle: 'Seja um dos primeiros a experimentar a próxima geração de soluções tecnológicas. Junte-se à nossa lista de espera exclusiva e mantenha-se atualizado sobre nosso lançamento revolucionário.',
    
    // Why Choose Z3C
    whyChoose: {
      title: 'Por que Escolher a Z3C?',
      experience: '20+ anos de experiência combinada em desenvolvimento de software',
      ai: 'Expertise de ponta em IA e machine learning',
      automation: 'Histórico comprovado em automação e otimização',
      security: 'Segurança e conformidade de nível empresarial',
      cloud: 'Soluções escaláveis nativas da nuvem'
    },
    
    // Countdown
    countdown: {
      title: 'Contagem Regressiva',
      days: 'Dias',
      hours: 'Horas',
      minutes: 'Minutos',
      seconds: 'Segundos',
      message: 'Até a revolução começar...'
    },
    
    // Form
    form: {
      title: 'Junte-se à Revolução',
      subtitle: 'Seja o primeiro a saber quando estivermos no ar',
      name: 'Nome Completo',
      namePlaceholder: 'Digite seu nome completo',
      email: 'Endereço de Email',
      emailPlaceholder: 'Digite seu endereço de email',
      company: 'Empresa (Opcional)',
      companyPlaceholder: 'Digite o nome da sua empresa',
      interest: 'Interesse Principal',
      interestPlaceholder: 'Selecione seu interesse principal',
      interests: {
        ai: 'Inteligência Artificial',
        automation: 'Automação de Processos',
        cloud: 'Soluções em Nuvem',
        security: 'Cibersegurança',
        analytics: 'Análise de Dados',
        consulting: 'Consultoria em Tecnologia'
      },
      message: 'Mensagem (Opcional)',
      messagePlaceholder: 'Conte-nos sobre seu projeto ou requisitos...',
      submit: 'Junte-se ao Futuro',
      submitting: 'Enviando...',
      successMessage: 'Obrigado por se juntar a nós! Te notificaremos quando fizermos o lançamento.',
      errorMessage: 'Algo deu errado. Tente novamente.'
    }
  },
  
  // Footer
  footer: {
    description: 'We Code What You Need - Desenvolvemos soluções personalizadas que atendem exatamente às suas necessidades tecnológicas.',
    contact: 'Contato',
    email: 'Email:',
    phone: 'Telefone:',
    schedule: 'Horário:',
    scheduleText: 'Seg-Qui: 08:00-18:00 | Sex: 08:00-14:00',
    specialties: 'Especialidades',
    development: 'Desenvolvimento Personalizado',
    consulting: 'Consultoria Técnica',
    ai: 'Desenvolvimento com IA',
    automation: 'Automação Avançada',
    copyright: 'Z3C - Soluções Profissionais em Tecnologia. Todos os direitos reservados.',
    poweredBy: 'Desenvolvido com ❤️ pela Z3C'
  },
  
  // Language names
  languages: {
    en: 'English',
    ptBR: 'Português (Brasil)',
    ptPT: 'Português (Portugal)',
    es: 'Español (Argentina)'
  }
}
